import { render, staticRenderFns } from "./fccInstrucoesCategorias.vue?vue&type=template&id=ad076e26"
import script from "./fccInstrucoesCategorias.vue?vue&type=script&lang=js"
export * from "./fccInstrucoesCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports